/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsBCSQuestionsAnswers {
    getFixupPrototypeFunction() { return AppSecopsBCSQuestionsAnswers.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsBCSQuestionsAnswers>): AppSecopsBCSQuestionsAnswers {
        let obj = Object.assign(new AppSecopsBCSQuestionsAnswers(), model);
        AppSecopsBCSQuestionsAnswers.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsBCSQuestionsAnswers>): AppSecopsBCSQuestionsAnswers {
        if (!model) return null;
        return AppSecopsBCSQuestionsAnswers.newInstance(<AppSecopsBCSQuestionsAnswers> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsBCSQuestionsAnswers) {
        if (!obj) return;

        models.AppSecopsBCSQuestionsAnswers.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsBCSQuestionsAnswers): boolean {
        Object.setPrototypeOf(obj, AppSecopsBCSQuestionsAnswers.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.version === undefined) {
            this.version = 0;
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (this.answers) {
            for (let val of this.answers) {
                models.AppSecopsBCSQuestionsAnswerItem.fixupPrototype(val);
            }
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Version number
     */
    version: number;

    /**
     * Slim weight entries [{id, weight}]
     */
    answers: Array<models.AppSecopsBCSQuestionsAnswerItem>;

    /**
     * When this version was created
     */
    created_at: Date;

    /**
     * Who created this version
     */
    created_by: string;

}
